import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setGetShift = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LIST_SHIFT_CASHIERS
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetShiftAction({
                    data: data.data,
                    countPage: data.countPage
                }))
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetShift as SetGetShift
}